/**
 * Extract readable plain text from a serialized Lexical editor state
 * (scene.data shape). Used for revision previews — one line per block node,
 * tabs/linebreaks preserved within blocks.
 */

const BLOCK_TYPES = new Set(['paragraph', 'heading', 'listitem', 'quote']);

const nodeText = (node) => {
  if (!node || typeof node !== 'object') return '';
  if (node.type === 'text') return node.text || '';
  if (node.type === 'linebreak') return '\n';
  if (node.type === 'tab') return '\t';
  if (Array.isArray(node.children)) {
    return node.children.map(nodeText).join('');
  }
  return '';
};

const collectBlocks = (node, blocks) => {
  if (!node || typeof node !== 'object') return;
  if (BLOCK_TYPES.has(node.type)) {
    blocks.push(nodeText(node));
    return;
  }
  if (Array.isArray(node.children)) {
    node.children.forEach((child) => collectBlocks(child, blocks));
  }
};

const lexicalToPlainText = (editorState) => {
  const root = editorState?.root;
  if (!root) return '';
  const blocks = [];
  collectBlocks(root, blocks);
  return blocks.join('\n');
};

export default lexicalToPlainText;
